// "Guests sent their selection" banners on the gallery list: one per gallery whose sending the
// Provider has not seen yet. The server keeps the flag (`Gallery.hasNewSelection`), so a banner
// closed here, or a gallery opened here or in the app, stays closed on every device; a new sending
// after an unlock shows again.
export function visibleSelectionBanners<T extends { hasNewSelection: boolean }>(galleries: T[]): T[] {
  return galleries.filter((gallery) => gallery.hasNewSelection);
}
